export const MESES = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
export const DIAS_SEMANA = ["LUN", "MAR", "MIÉ", "JUE", "VIE", "SÁB", "DOM"];

// Date.getDay() regresa 0=domingo..6=sábado; esto lo convierte a 0=lunes..6=domingo
const diaSemanaLunesPrimero = (fecha) => (fecha.getDay() + 6) % 7;

// El backend manda fecha_visita/createdate como texto (con hora incluida y formato variable
// según el origen: ISO, MM/dd/yyyy, etc.) — esto siempre lo normaliza a dd/mm/aaaa
export const soloFecha = (valor) => {
  if (!valor) return "";
  const texto = String(valor).split(" ")[0].split("T")[0];

  // yyyy-MM-dd (ISO)
  const iso = texto.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;

  // MM/dd/yyyy
  const mdy = texto.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (mdy) return `${mdy[2].padStart(2, "0")}/${mdy[1].padStart(2, "0")}/${mdy[3]}`;

  const fecha = new Date(valor);
  if (!isNaN(fecha)) {
    const dd = String(fecha.getDate()).padStart(2, "0");
    const mm = String(fecha.getMonth() + 1).padStart(2, "0");
    return `${dd}/${mm}/${fecha.getFullYear()}`;
  }

  return texto;
};

export const iniciales = (nombre) =>
  (nombre || "").split(" ").filter(Boolean).map((w) => w[0]).slice(0, 2).join("").toUpperCase();

// Colores por vendedor — asignación estable por hash simple del nombre, sin catálogo fijo
const PALETA_VENDEDOR = ["#1e3a5f", "#b8860a", "#1e5b34", "#7c3f8c", "#a4522d", "#0f6674"];
export const colorVendedor = (nombre) => {
  const n = (nombre || "").trim();
  if (!n) return PALETA_VENDEDOR[0];
  let hash = 0;
  for (let i = 0; i < n.length; i++) hash = (hash * 31 + n.charCodeAt(i)) >>> 0;
  return PALETA_VENDEDOR[hash % PALETA_VENDEDOR.length];
};

// Opciones de estatus para filtros (código corto + texto legible)
export const ESTATUS_VISITA = [
  { codigo: "P", texto: "Pendiente" },
  { codigo: "R", texto: "Realizada" },
  { codigo: "V", texto: "Vencida" },
];

// Colores por estatus — usa el código corto (estatus: 'P'/'R'/'V'), no el texto
export const estiloEstatus = (estatus) => {
  const mapa = {
    P: { bg: "#fff6d9", fg: "#8a6d00" },
    R: { bg: "#e8f0e9", fg: "#1e5b34" },
    V: { bg: "#fde8e6", fg: "#b3261e" },
  };
  return mapa[estatus] || mapa.P;
};

// Construye las 35/42 celdas del mes (incluye días del mes anterior/siguiente para completar semanas).
// "filas" trae fechaObj (Date real, parseada de fecha_visita) en cada visita.
export const construirCalendario = (anio, mesIdx, filas) => {
  const primerDia = new Date(anio, mesIdx, 1);
  const inicioSemana = diaSemanaLunesPrimero(primerDia);
  const diasDelMes = new Date(anio, mesIdx + 1, 0).getDate();
  const diasMesAnterior = new Date(anio, mesIdx, 0).getDate();

  const celdas = [];
  for (let i = 0; i < inicioSemana; i++) {
    celdas.push({ numero: diasMesAnterior - inicioSemana + 1 + i, actual: false });
  }
  for (let d = 1; d <= diasDelMes; d++) {
    celdas.push({ numero: d, actual: true });
  }
  while (celdas.length % 7 !== 0 || celdas.length < 35) {
    celdas.push({ numero: celdas.length - inicioSemana - diasDelMes + 1, actual: false });
  }

  return celdas.map((c) => ({
    ...c,
    visitas: c.actual
      ? filas.filter((v) => v.fechaObj.getDate() === c.numero && v.fechaObj.getMonth() === mesIdx && v.fechaObj.getFullYear() === anio)
      : [],
  }));
};

// Construye los 7 días de la semana que contiene la fecha ancla (un Date real, no relativo a "hoy")
export const construirSemana = (fechaAncla, filas) => {
  const lunes = new Date(fechaAncla);
  lunes.setDate(fechaAncla.getDate() - diaSemanaLunesPrimero(fechaAncla));

  const dias = [];
  for (let i = 0; i < 7; i++) {
    const d = new Date(lunes);
    d.setDate(lunes.getDate() + i);
    dias.push(d);
  }

  return dias.map((d) => {
    const dy = d.getFullYear(), dm = d.getMonth(), dd = d.getDate();
    return {
      fecha: d,
      numero: dd,
      mes: dm,
      anio: dy,
      diaSemana: DIAS_SEMANA[diaSemanaLunesPrimero(d)],
      visitas: filas.filter((v) => v.fechaObj.getFullYear() === dy && v.fechaObj.getMonth() === dm && v.fechaObj.getDate() === dd),
    };
  });
};
